movieSymbolAnimatorDU = {};
movieSymbolAnimatorDU.activeSuperWilds = [];

movieSymbolAnimatorDU.playAnimation = function (sequence, completeCallback) {
  movieSymbolAnimatorDU.sequence = sequence;
  gameController.saveLastWinPositionData(sequence);
  pulseSymbolAnimation.completeCallback = completeCallback;

  movieSymbolAnimatorDU.soundFinished = true;
  if (typeof sequence.sound !== 'undefined') {
    movieSymbolAnimatorDU.soundFinished = false;
    let highPaySym = false;
    if (
      sequence.sound !== 'ace' ||
      sequence.sound !== 'king' ||
      sequence.sound !== 'queen' ||
      sequence.sound !== 'jack'
    ) {
      highPaySym = true;
      musicManager.onSymbolWinlineStart();
    }

    soundManager.play(sequence.sound, movieSymbolAnimatorDU.onSoundFinished(highPaySym));
  }

  // Hide reel symbols
  for (var i = 0; i < sequence.data.length; i++) {
    reelManager.reels[sequence.data[i].reel].showSymbol(sequence.data[i].row, false);
  }

  movieSymbolAnimatorDU.activeSuperWilds = []; //superWildDisplay.getActiveReels();

  if (gameController.canCelebrate || freespins.inFreespins) {
    for (var i = 0; i < movieSymbolAnimatorDU.sequence.data.length; i++) {
      for (j = 0; j < reelManager.reels[movieSymbolAnimatorDU.sequence.data[i].reel].linkedAnimations.length; j++) {
        var superWild = false;
        for (var k = 0; k < movieSymbolAnimatorDU.activeSuperWilds.length; k++) {
          if (movieSymbolAnimatorDU.activeSuperWilds[k] === movieSymbolAnimatorDU.sequence.data[i].reel) {
            superWild = true;
          }
        }

        if (!superWild) {
          var animStrip = resourceManager.get(
            reelManager.reels[movieSymbolAnimatorDU.sequence.data[i].reel].linkedAnimations[j].name
          );

          animStrip.showAnimation(
            movieSymbolAnimatorDU.sequence.data[i].row,
            movieSymbolAnimatorDU.sequence.data[i].symbolIndex
          );
        }
      }
    }
  }

  Reflex.addToUpdate(movieSymbolAnimatorDU.update);
};

movieSymbolAnimatorDU.skipAnimation = function () {
  if (checkForDefined(movieSymbolAnimatorDU.sequence.sound)) {
    soundManager.stop(movieSymbolAnimatorDU.sequence.sound);
  }
  movieSymbolAnimatorDU.soundFinished = true;

  if (movieSymbolAnimatorDU.isAnimationComplete()) {
    symbolWinBorderAnim.stopAllAnimations();
  } else {
    for (var i = 0; i < movieSymbolAnimatorDU.sequence.data.length; i++) {
      for (j = 0; j < reelManager.reels[movieSymbolAnimatorDU.sequence.data[i].reel].linkedAnimations.length; j++) {
        var superWildOnReel = false;

        for (var k = 0; k < movieSymbolAnimatorDU.activeSuperWilds.length; k++) {
          if (movieSymbolAnimatorDU.activeSuperWilds[k] === movieSymbolAnimatorDU.sequence.data[i].reel) {
            superWildOnReel = true;
          }
        }

        if (!superWildOnReel) {
          resourceManager
            .get(reelManager.reels[movieSymbolAnimatorDU.sequence.data[i].reel].linkedAnimations[j].name)
            .stopAnimation(movieSymbolAnimatorDU.sequence.data[i].row);
        }
      }
    }
  }

  movieSymbolAnimatorDU.clearAnimations();
  Reflex.removeFromUpdate(movieSymbolAnimatorDU.update);
  pulseSymbolAnimation.completeCallback();
};

movieSymbolAnimatorDU.onSoundFinished = function (isHighPay) {
  if (isHighPay) {
    musicManager.onSymbolWinlineEnd();
  }
  movieSymbolAnimatorDU.soundFinished = true;
};

movieSymbolAnimatorDU.update = function () {
  if (movieSymbolAnimatorDU.isAnimationComplete()) {
    movieSymbolAnimatorDU.clearAnimations();
    movieSymbolAnimatorDU.playBorderAnim();
    // gameController.createBonusOverlays();
    Reflex.removeFromUpdate(movieSymbolAnimatorDU.update);
  }
};

movieSymbolAnimatorDU.isAnimationComplete = function () {
  for (var i = 0; i < movieSymbolAnimatorDU.sequence.data.length; i++) {
    for (j = 0; j < reelManager.reels[movieSymbolAnimatorDU.sequence.data[i].reel].linkedAnimations.length; j++) {
      if (
        resourceManager
          .get(reelManager.reels[movieSymbolAnimatorDU.sequence.data[i].reel].linkedAnimations[j].name)
          .isAnimationPlaying(movieSymbolAnimatorDU.sequence.data[i].row)
      ) {
        return false;
      }
    }
  }

  return true;
};

movieSymbolAnimatorDU.clearAnimations = function () {
  for (var i = 0; i < movieSymbolAnimatorDU.sequence.data.length; i++) {
    for (j = 0; j < reelManager.reels[movieSymbolAnimatorDU.sequence.data[i].reel].linkedAnimations.length; j++) {
      var animStrip = resourceManager.get(
        reelManager.reels[movieSymbolAnimatorDU.sequence.data[i].reel].linkedAnimations[j].name
      );
      animStrip.hideAllAnimations();
    }
  }

  // Show reel symbols
  for (var i = 0; i < movieSymbolAnimatorDU.sequence.data.length; i++) {
    reelManager.reels[movieSymbolAnimatorDU.sequence.data[i].reel].showSymbol(
      movieSymbolAnimatorDU.sequence.data[i].row,
      true
    );
  }
};

movieSymbolAnimatorDU.playBorderAnim = function () {
  symbolWinBorderAnim.playAnimation(movieSymbolAnimatorDU.sequence, movieSymbolAnimatorDU.borderAnimComplete);
};

movieSymbolAnimatorDU.borderAnimComplete = function () {
  pulseSymbolAnimation.completeCallback();
};

resourceManager.registerPlugIn('movieSymbolAnimatorDU', movieSymbolAnimatorDU);
